var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{staticClass:"popupDraw",attrs:{"round":true},on:{"click-overlay":_vm.close},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"gift"},[_c('img',{staticClass:"bg",attrs:{"src":"https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/funGame/giftbg.png"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }